// extracted by mini-css-extract-plugin
export default {"animated_bg":"AnimatedBackground_animated_bg__0SwYv","animate":"AnimatedBackground_animate__uH89j"};